<script setup lang="ts">
import type { QueryStatus } from "@tanstack/vue-query";

defineProps<{
  queryStatus: QueryStatus;
}>();
</script>
<template>
  <div :aria-busy="queryStatus == 'pending'">
    <template v-if="queryStatus == 'success'"><slot /></template>
    <div v-else-if="queryStatus == 'error'" class="loading-failed">
      <span class="error"> Etwas ist schiefgelaufen. </span>
    </div>
  </div>
</template>

<style scoped>
.loading-failed {
  text-align: center;
}
</style>
